"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.HotArticleEntity = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../../../types");
var constants_1 = require("../../../constants");
var fields_1 = require("../../../fields");
var article_factory_1 = require("./article-factory");
exports.HotArticleEntity = article_factory_1.articleFactory(types_1.PageType.HOT_ARTICLE, function (prismicDoc, normalizedArticle, logger) {
    var _a;
    var _b, _c, _d, _e, _f;
    return utils_1.compact(__assign(__assign({}, normalizedArticle), { filters: utils_1.compact((_a = {},
            _a[types_1.Filter.Category] = logger.required(constants_1.toCategory((_b = prismicDoc === null || prismicDoc === void 0 ? void 0 : prismicDoc.data) === null || _b === void 0 ? void 0 : _b.category, logger)),
            _a[types_1.Filter.Localization] = constants_1.toLocalizationFilter((_c = prismicDoc === null || prismicDoc === void 0 ? void 0 : prismicDoc.data) === null || _c === void 0 ? void 0 : _c.localization, logger),
            _a[types_1.Filter.Thematic] = logger.required(constants_1.toThematic((_d = prismicDoc === null || prismicDoc === void 0 ? void 0 : prismicDoc.data) === null || _d === void 0 ? void 0 : _d.thematic, logger)),
            _a)), publicationDate: fields_1.toTimestamp((_e = prismicDoc === null || prismicDoc === void 0 ? void 0 : prismicDoc.data) === null || _e === void 0 ? void 0 : _e.publication_date), onHome: fields_1.toBoolean((_f = prismicDoc === null || prismicDoc === void 0 ? void 0 : prismicDoc.data) === null || _f === void 0 ? void 0 : _f.onHome) }));
});
//# sourceMappingURL=hot-article.js.map